/** OnboardL13Details — thin route wrapper for the shared L13 wizard.
 *
 *  The user picks Distributor vs Sales Agent on /onboard/distributor
 *  (see OnboardDistributorType) which then routes here with
 *  location.state.kind in {"distributor", "sales_agent"}.
 *
 *  We delegate to OnboardGeneric which already has KIND_CFG entries for
 *  both. If the user lands here directly (no route state, e.g. via a
 *  browser refresh mid-wizard) we bounce them back to the picker.
 */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OnboardGeneric from "@/pages/OnboardGeneric";

const VALID = new Set(["distributor", "sales_agent"]);

export default function OnboardL13Details() {
  const loc = useLocation();
  const nav = useNavigate();
  const kind = loc.state?.kind;

  useEffect(() => {
    if (!kind || !VALID.has(kind)) {
      nav("/onboard/distributor", { replace: true });
    }
  }, [kind, nav]);

  if (!kind || !VALID.has(kind)) return null;
  return <OnboardGeneric kind={kind} />;
}
